(function() {
  if (window.__moxPlpListTableInit) return;
  window.__moxPlpListTableInit = true;
  var storagePrefix = 'mox-plp-layout:';

  function getSection(sectionId) {
    return document.getElementById('shopify-section-' + sectionId);
  }

  function getStorageKey(sectionId) {
    return storagePrefix + sectionId;
  }

  function readStoredLayout(sectionId) {
    try {
      return window.localStorage.getItem(getStorageKey(sectionId));
    } catch (error) {
      return null;
    }
  }

  function writeStoredLayout(sectionId, targetLayout) {
    try {
      window.localStorage.setItem(getStorageKey(sectionId), targetLayout);
    } catch (error) {}
  }

  function persistLayout(targetLayout) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { products_items_per_row: targetLayout } }),
      keepalive: true
    }).catch(function(error) {
      console.error('mox-plp-layout-switch:', error);
    });
  }

  function updateSwitchStates(section, targetLayout) {
    var switches = section.querySelectorAll('.mox-plp-layout-switch');

    switches.forEach(function(switchEl) {
      var selector = 'button[is="hdt-switch-to-list-view"]';
      var activeButton;

      switchEl.setAttribute('views', targetLayout);
      switchEl.querySelectorAll('button[type="button"]').forEach(function(button) {
        button.classList.remove('is-active');
      });

      if (targetLayout !== '0.0.0') {
        selector = switchEl.getAttribute('breakpoint') === 'desktop'
          ? 'button.hdt_btn_layout4'
          : 'button.hdt_btn_layout2';
      }

      activeButton = switchEl.querySelector(selector);
      if (activeButton) activeButton.classList.add('is-active');
    });
  }

  function updatePanels(section, targetLayout) {
    var listPanel = section.querySelector('[data-mox-plp-panel="list"]');
    var gridPanel = section.querySelector('[data-mox-plp-panel="grid"]');

    if (!listPanel || !gridPanel) return;

    listPanel.classList.toggle('hdt-hidden', targetLayout !== '0.0.0');
    gridPanel.classList.toggle('hdt-hidden', targetLayout === '0.0.0');
  }

  function applyStoredLayout(sectionId, preferredLayout) {
    var section = getSection(sectionId);
    var targetLayout = preferredLayout || readStoredLayout(sectionId);

    if (!section || !targetLayout) return;

    updateSwitchStates(section, targetLayout);
    updatePanels(section, targetLayout);
  }

  function syncSectionFromEventTarget(target) {
    var section = target && target.closest ? target.closest('.shopify-section') : null;
    var switchEl;
    var sectionId;

    if (!section) return;

    switchEl = section.querySelector('.mox-plp-layout-switch');
    if (!switchEl) return;

    sectionId = switchEl.getAttribute('section-id');
    if (!sectionId) return;

    applyStoredLayout(sectionId);
  }

  document.addEventListener('click', function(event) {
    var layoutButton = event.target.closest('.mox-plp-layout-switch button[type="button"]');
    var switchEl;
    var sectionId;
    var targetLayout;

    if (!layoutButton) return;

    switchEl = layoutButton.closest('.mox-plp-layout-switch');
    if (!switchEl) return;

    sectionId = switchEl.getAttribute('section-id');
    targetLayout = layoutButton.hasAttribute('is') ? '0.0.0' : '2.2.4';

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!sectionId) return;

    writeStoredLayout(sectionId, targetLayout);
    applyStoredLayout(sectionId, targetLayout);
    persistLayout(targetLayout);
  }, true);

  document.querySelectorAll('.mox-plp-layout-switch').forEach(function(switchEl) {
    var sectionId = switchEl.getAttribute('section-id');

    if (!sectionId) return;
    applyStoredLayout(sectionId);
  });

  document.addEventListener('products:update', function(event) {
    syncSectionFromEventTarget(event.target);
  });

  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-mox-plp-toggle]');
    if (!toggle) return;

    var targetId = toggle.getAttribute('aria-controls');
    if (!targetId) return;

    var content = document.getElementById(targetId);
    if (!content) return;

    event.preventDefault();

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    var nextExpanded = !expanded;

    toggle.setAttribute('aria-expanded', String(nextExpanded));
    content.hidden = !nextExpanded;

    var label = toggle.querySelector('[data-mox-toggle-label]');
    var showLabel = toggle.getAttribute('data-show-label') || '';
    if (label) label.textContent = showLabel;

    var group = toggle.closest('.mox-plp-list-table__group');
    if (group) group.classList.toggle('is-expanded', nextExpanded);
  });
})();
